module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-policy-button"
  }, [_c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'group',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_vm._v("Edit")]), _c('ActionButton', {
    attrs: {
      "action": _vm.remove,
      "confirm": true
    }
  }, [_vm._v("Delete")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46a3dede!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/GroupButtons.vue
// module id = 2443
// module chunks = 1